import React from 'react';
import styles from './index.module.scss';

export const DraggableListItem: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);
